import merge from 'lodash/merge';

export default function mergeReducer(state, action) {
	return merge(Array.isArray(action.value) ? [] : {}, state, action.value);
}
